module.exports = __webpack_public_path__ + "static/media/study 220713.c7faea38.png";